import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 24754 17218"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#fefefe;stroke-width:728.051}.fil1{fill:#fefefe}.fil0{fill:#2b2a29}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974604515552">
        <path
          d="M23991 0H763C343 0 0 343 0 763v9010c0 420 343 763 763 763h23228c419 0 763-343 763-763V763c0-420-344-763-763-763zM3366 1332c505 0 915 409 915 915 0 505-410 915-915 915s-915-410-915-915c0-506 410-915 915-915zM12377 12394c-172 0-311 139-311 311v4202c0 172 139 311 311 311s311-139 311-311v-4202c0-172-139-311-311-311zM16023 12540c-73-156-258-224-414-151-155 72-223 258-150 413l1555 3339c53 113 165 179 282 179 44 0 89-9 131-29 156-73 223-257 151-413l-1555-3338zM19541 12520c-83-150-273-204-423-121-150 84-204 273-120 423l1189 2135c57 103 163 160 272 160 51 0 103-12 151-39 150-84 204-273 121-423l-1190-2135zM9144 12389c-155-73-340-5-413 151l-1555 3338c-72 156-5 340 150 413 43 20 88 29 131 29 118 0 230-66 283-179l1555-3339c72-155 5-341-151-413zM5635 12399c-149-83-339-29-423 121l-1189 2135c-83 150-29 339 121 423 47 27 99 39 151 39 109 0 215-57 272-160l1189-2135c83-150 29-339-121-423z"
          className="fill"
        />
        <rect
          width={20474}
          height={622}
          x={2140}
          y={5910}
          className=""
          // rx={7509}
          // ry={7281}
          style={{
            strokeWidth: 728.051,
            stroke: "#fefefe",
          }}
        />
        <rect
          width={20474}
          height={622}
          x={2140}
          y={8458}
          className=""
          // rx={7509}
          // ry={7281}
          style={{
            strokeWidth: 728.051,
            stroke: "#fefefe",
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
